<template>
  <v-tooltip bottom color="#2C2C2C">
    <template v-slot:activator="{ on, attrs }">
      <button
        v-if="openModal"
        type="button"
        v-bind="attrs"
        v-on="on"
        @click.stop="openModal"
        class="delete_button"
      >
        <IconsButton icon="button-delete" />
      </button>
      <button
        v-else
        v-bind="attrs"
        v-on="on"
        @click="deleteItem(deleteItemIndex)"
        type="button"
        class="delete_button"
      >
        <IconsButton icon="button-delete" />
      </button>
    </template>
    <span>{{ localStorage.translations.pages.common['buttons']['udalit'] }}</span>
  </v-tooltip>
</template>

<script>
import IconsButton from 'components/icons/button/IconsButton'

export default {
  name: 'DeleteBtn',
  components: { IconsButton },
  props: ['vBind', 'vOn', 'openModal', 'deleteItem', 'deleteItemIndex', 'click'],
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.delete_button {
  display: grid;
  align-items: center;
  justify-content: center;
  position: relative;
  svg:deep() {
    path {
      fill: #ec1b0e;
    }
  }
  &:hover {
    .arrow-5 {
      display: block;
    }
    svg:deep() {
      path {
        fill: #cf1d13;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 0 !important;
    background: #eb5757;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    svg:deep() {
      path {
        fill: #ffffff;
      }
    }
    &:hover {
      opacity: 0.9;
      svg:deep() {
        path {
          fill: #ffffff;
        }
      }
    }
  }
}
</style>
